import React from 'react';
import CourseCard from './CourseCard';
import './CourseList.css';

const CourseList = ({ courses }) => {
  if (!courses.length) {
    return <p className="cf-course-empty">No courses match your search. Try a different keyword.</p>;
  }

  return (
    <section className="cf-course-list" aria-label="Available courses">
      {courses.map((course) => (
        <CourseCard key={course.id} course={course} />
      ))}
    </section>
  );
};

export default CourseList;


